import defaultClient from '@src/api/clients/default';

export function fetchPacingHolds(params = {}) {
  return defaultClient.request({
    url: 'dashboard/pacing-holds/',
    method: 'GET',
    options: { params },
  });
}

export function createPacingHold(payload) {
  return defaultClient.request({
    url: 'dashboard/pacing-holds/',
    method: 'POST',
    payload,
  });
}

export function cancelPacingHold(holdId) {
  return defaultClient.request({
    url: `dashboard/pacing-holds/${holdId}/cancel/`,
    method: 'POST',
  });
}

export function fetchPacingGatingRules() {
  return defaultClient.request({
    url: 'dashboard/pacing-holds/gating-rules/',
    method: 'GET',
  });
}
